import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SurveyModule } from 'survey-angular-ui';
import { FormDropdownQuestionComponent } from './form-dropdown-question.component';

@NgModule({
  declarations: [
    FormDropdownQuestionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SurveyModule,
  ],
  exports: [
    FormDropdownQuestionComponent,
  ]
})
export class FormDropdownQuestionModule {
}
